import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useDeleteKeepInTouchConfiguration = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (id: string) => {
			return userSession.webServiceHelper.callAsync<void>(`KeepInTouchJobConfiguration/${id}`, 'DELETE', null);
		},
		onError,
		onSuccess,
	});
};
